const scheduleMods = {
  NotActivated: {
    title: "Not Activated",
    value: "NotActivated"
  },
  Submitted: {
    title: "Submitted",
    value: "Submitted"
  },
  Saved: {
    title: "Saved",
    value: "Saved"
  },
  Open: {
    title: "Open",
    value: "Open"
  },
  ComingDue: {
    title: "Coming Due in 48 hours",
    value: "ComingDue"
  },
  Late: {
    title: "Late Services",
    value: "Late"
  }
};

export const scheduleModsMerchandiser = {
    Open: {
        title: "Open",
        value: "Open"
      },
    Saved: {
      title: "Saved",
      value: "Saved"
    },
    Submitted: {
      title: "Submitted",
      value: "Submitted"
    }
  };

export default scheduleMods;
